module.exports = __webpack_public_path__ + "img/coupon_pc_tab_01.3a1f7e88.png";